"use strict";
/**
 * @file Created on 02.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NChangedWinDate_1 = require("../model/NChangedWinDate");

var NChangedWinDateConverter_1 = require("./NChangedWinDateConverter");
/**
 * @author Tomas Leity
 */


var NChangedWinDateConverterImpl =
/*#__PURE__*/
function (_NChangedWinDateConve) {
  _inherits(NChangedWinDateConverterImpl, _NChangedWinDateConve);

  function NChangedWinDateConverterImpl() {
    _classCallCheck(this, NChangedWinDateConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedWinDateConverterImpl).apply(this, arguments));
  }

  _createClass(NChangedWinDateConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NChangedWinDate_1.NChangedWinDate(NChangedWinDate_1.NChangedWinDate.schema.windowId.valueOf(conversions.toClassReferenceId(source.windowId)), NChangedWinDate_1.NChangedWinDate.schema.newDateFrom.valueOf(conversions.toDate(source.newDateFrom)), NChangedWinDate_1.NChangedWinDate.schema.newDateTo.valueOf(conversions.toDate(source.newDateTo)), NChangedWinDate_1.NChangedWinDate.schema.oldDateFrom.valueOf(conversions.toDate(source.oldDateFrom)), NChangedWinDate_1.NChangedWinDate.schema.oldDateTo.valueOf(conversions.toDate(source.oldDateTo)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        windowId: conversions.toDocumentReferenceId(source.windowId),
        newDateFrom: conversions.fromDate(source.newDateFrom),
        newDateTo: conversions.fromDate(source.newDateTo),
        oldDateFrom: conversions.fromDate(source.oldDateFrom),
        oldDateTo: conversions.fromDate(source.oldDateTo)
      });
      return result;
    }
  }]);

  return NChangedWinDateConverterImpl;
}(NChangedWinDateConverter_1.NChangedWinDateConverter);

exports.NChangedWinDateConverterImpl = NChangedWinDateConverterImpl;
/**
 * IOC Container qualifier
 */

NChangedWinDateConverterImpl.QUALIFIER = {
  documentType: NChangedWinDate_1.NChangedWinDate.name
};